import Link from "next/link";
import {twMerge} from "tailwind-merge";

export default function Breadcrumb({routes, classes = {}}) {
    const {parentClasses = "", iconClasses = "", lastLinkClasses = "", linkClasses = ""} = classes;

    return (
        <ul className={twMerge("flex items-center gap-x-1 lg:gap-x-3 text-sm lg:text-base w-full lg:w-[90%]", parentClasses)}>
            {
                routes.map((route, index) => (
                    <li key={index} className={routes.length === index+1 ? twMerge("truncate text-white", lastLinkClasses) : twMerge("whitespace-nowrap text-pol-orange-dark", linkClasses)}>
                        {
                            route.url ?  <Link href={route.url}>{route.title}</Link> : <p className="inline">{route.title}</p>
                        }

                        {
                            routes.length === index+1 ? null :
                                <i className={twMerge("icon-simple-arrow-left inline-block text-pol-dark-450 text-xs mr-1 lg:mr-3", iconClasses)} />
                        }
                    </li>
                ))
            }
        </ul>
    )
}
